
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: { Bar },
  props: {
    title: {
      type: String,
      required: true,
    },
    chart: {
      // image
      type: Object,
      required: true,
    },
    bgImage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartData: [],
      chartLabels: [],
      filteredChartData: {},
      forceReRender: 0,
    }
  },
  async fetch() {
    return await this.$axios
      .get('https://v2-api.wellcertified.com/api/well/mom-stats')
      .then((res) => {
        this.chartData = [
          ...this.formatChartData(res.data),
          // ...['4930000000', '4930000000', '4930000000'],
        ]
        this.chartLabels = this.formatChartLabels(res.data)

        // console.log('chartData', this.chartData)
      })
      .then(() => {
        if (this.$matchMedia('md')) {
          this.updateChart()
        } else {
          this.updateChart(true)
        }
      })
      .catch((res) => {
        if (!res.response) {
          console.error('no res', res)
        }
      })
  },
  computed: {
    barChartOptions() {
      const newOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // indexAxis: 'y',
        scales: {
          y: {
            position: 'right',
            ticks: {
              // padding: 10,
              color: '#fff',
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback(value, index, ticks) {
                if (index === 0) return null
                return Number(value) / 1000000000 + ' B' || null
              },
              beginAtZero: false,
            },
            grid: {
              // display: false,
              tickColor: 'rgba(60, 158, 183, .5)',
              color: 'rgba(60, 158, 183, .5)',
              drawBorder: false, // <-- this removes y-axis line
            },
            // beginAtZero: true,
          },
          x: {
            // display: false,
            // min: 0,
            // max: 90,
            ticks: {
              // padding: 10,
              color: '#fff',
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
            },
            grid: {
              borderColor: '#fff',
              display: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false, // <-- this option disables tooltips
          },
        },
      }

      return newOptions
    },
  },
  watch: {
    '$store.state.app.breakpoint'(val) {
      if (this.$matchMedia('md')) {
        this.updateChart()
      } else {
        this.updateChart(true)
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const TL1 = this.$gsap.timeline({
        scrollTrigger: {
          scrub: true,
          trigger: this.$refs.container,
          start: '10% bottom',
          end: 'bottom center+=20px',
          // markers: true,
          toggleActions: 'restart',
        },
      })

      TL1.from(this.$refs.chart.$el, {
        alpha: 0,
        duration: 1.25,
        onToggle: this.animateChart,
        onStart: () => this.animateChart(),
      })

      TL1.from('.graph-line', {
        scaleX: 0,
        duration: 3,
        stagger: 0.15,
        ease: 'Power3.easeInOut',
      })

      TL1.from('.graph-marker', {
        alpha: 0,
        duration: 3,
        stagger: 0.2,
        ease: 'Power3.easeInOut',
      })
    },
    formatChartData(data) {
      const formattedData = data.reduce((prev, current) => {
        const [num, area] = current?.total_area?.split(' ') ?? [null, null]
        if (!num || !area) {
          return null
        }
        const clonePrev = [...prev]

        switch (area.toLowerCase()) {
          case 'thousand':
            clonePrev.push(Number(num * 1000).toFixed(0))
            break
          case 'million':
            clonePrev.push(Number(num * 1000000).toFixed(0))
            break
          case 'billion':
            clonePrev.push(Number(num * 1000000000).toFixed(0))
            break
          default:
            return null
        }
        return clonePrev
      }, [])

      return formattedData
    },
    formatChartLabels(data) {
      // const formattedLabels = data.map((x) => x.year)
      let prev = null
      const formattedLabels = data.reduce((acc, next) => {
        let nextLabel = null

        if (prev === next.year) {
          nextLabel = ''
        } else {
          nextLabel = next.year
        }

        prev = next.year

        return [...acc, nextLabel]
      }, [])

      return formattedLabels
    },
    updateChart(isMobile = false) {
      this.filteredChartData = {
        labels: isMobile ? this.chartLabels.slice(50) : this.chartLabels,
        datasets: [
          {
            backgroundColor: 'rgba(171, 205, 232, 1)',
            data: isMobile ? this.chartData.slice(50) : this.chartData,
            // barThickness: 6,
          },
        ],
      }
    },
    animateChart() {
      this.forceReRender += 1
    },
  },
}
